import APIS from "./APIS"
import Cookies from "universal-cookie"

import { renewSocket } from "../contexts/SocketContext"

const isBrowser = typeof window !== `undefined`

export const setUser = (user) => {
  (window.localStorage.risUpUser = JSON.stringify(user))
}

const getUser = () => {
  if (window.localStorage.risUpUser) {
    let user = JSON.parse(window.localStorage.risUpUser)
    return user ? user : {}
  }
  return {}
}

export const isLoggedIn = () => {
  if (!isBrowser) return false

  const user = getUser()
  if (user && user.id && user.email) {
    return user.id
  } else {
    return false
  }
}

export const logout = callback => {
  if (!isBrowser) return
  const cookies = new Cookies()
  const cookieNames = Object.keys(cookies.getAll())
  cookieNames.forEach((cook) => {
    let searchString = process.env.REACT_APP_COOKIES_SESSION || "pp.connect.sid"
    if (cook.includes(searchString)) {
      let host = document.location.hostname
      let arr = host.split(".")
      if (arr.length === 1) {
        host = arr[0]
      } else {
        arr = arr.slice(-arr.length+1)
        host = "."+arr.join(".")
      }
      cookies.remove(cook, { path: '/', domain : host })
    }
  })
  setUser({})
  renewSocket();
  callback()
}


export const getCurrentUser = () => isBrowser && getUser()
